<button (click)="close(false)" class="modal-close"></button>

<h4 class="modal-title" *ngIf="data.title">{{ data.title }}</h4>

<div class="modal-content">
  <p class="modal-intro">
    <span i18n="Modal|Are you sure you want to delete @@deleteModalIntro"
      >Are you sure you want to delete
    </span>
    <strong>{{ data.whatToDelete }}</strong>
    <span>?</span>
  </p>
</div>

<div class="modal-footer">
  <button
    (click)="close(false)"
    class="o-button o-button--default"
    i18n="Button|No Button @@buttonNo"
  >
    No
  </button>
  <button (click)="close(true)" class="o-button o-button--danger">
    <span i18n="Button|Yes, delete @@buttonYesDelete">Yes, delete </span>
    {{ data.typeToDelete }}
  </button>
</div>
